/**
 * Created by razial on 09.01.2021
 */

const PrizeView = cc.Scale9Sprite.extend({
    ctor: function (prizes, options) {
        const styles = cleverapps.styles.PrizeView;

        let icon;

        prizes = prizes || {};

        const prizeToString = function (prize) {
            if (prize instanceof Unit) {
                return prize.getKey();
            }
            return JSON.stringify(prize);
        };

        if (prizes.waiting) {
            icon = new cleverapps.Spine(bundles.small_timer_merge.jsons.timer_json);
            icon.setScale(styles.animation.scale || 1.0);
            icon.setAnchorPoint(0.5, 0.5);
            icon.setAlignment(styles.animation);
            icon.setAnimation(0, "animation", true);
        } else if (prizes.minigame) {
            icon = new cc.Sprite(bundles.reward_icons_merge.frames.pickaxe);
        } else if (prizes.sprite) {
            icon = new cc.Sprite(prizes.sprite);
        } else {
            const location = cleverapps.meta.getSelectedLocation();

            const otherUnits = prizes.filter((unit) => !unit.resource && !unit.ingredient && location.families && !location.families[unit.code]);

            if (otherUnits.length > 0) {
                cleverapps.throwAsync(`Other world units in prizes - ${otherUnits.map(prizeToString).join(",")
                } - for unit ${options.unit && options.unit.getKey()}`);
            }

            const prize = prizes[0];
            if (prize && prize.resource) {
                icon = new Reward(prize.resource, prize.amount).getSmallIcon();
            } else if (prize && prize.ingredient) {
                icon = Map2dLocation.currentLocation.harvested.getIngredientSmallIcon(prize.ingredient);
            } else if (prize && prize.code !== undefined && prize.stage !== undefined) {
                icon = UnitView.getUnitImage(prize, { alignAnchorX: true });
                if (icon.clearTrack) {
                    icon.setAnimationFrame(0, 0);
                    icon.clearTrack(0);
                }
            } else {
                cleverapps.throwAsync(`Empty sprite prize - ${prizeToString(prizes)
                } - for unit ${options.unit && options.unit.getKey()}`);
                icon = new cc.Node();
            }
        }

        this._super(options.warning ? bundles.merge.frames.background_warning : bundles.merge.frames.background);

        this.debugId = "PrizeView";

        this.setAnchorPoint(0.5, 0);
        this.setLocalZOrder(1);

        if (styles.width && styles.height) {
            const scale = cleverapps.meta.getSelectedLocation().locationConfig.largerPrizeAndCustomerViews ? 1.2 : 1;
            this.setContentSize2(styles.width * scale, styles.height * scale);
        }

        if (cleverapps.gameModes.silentInfoView || cleverapps.config.demoMode) {
            this.setVisible(false);
        }

        const pointerSprite = options.warning === true ? bundles.merge.frames.pointer2_warning : bundles.merge.frames.pointer2;
        if (pointerSprite) {
            const pointer = new cc.Sprite(pointerSprite);
            pointer.setAnchorPoint(0.5, 0.5);
            pointer.setAlignment(this.width / 2, styles.pointer.dy);
            this.addChild(pointer);
        }

        icon.setAlignment(this.width / 2, this.height / 2 + styles.iconDy);
        cleverapps.UI.fitToBox(icon, {
            width: this.width - styles.padding.x * 2,
            height: this.height - styles.padding.y * 2
        });
        this.addChild(icon);

        if (options.onClick && !cleverapps.environment.isSceneWithPreview()) {
            cleverapps.UI.onClick(this, this.createListener(options.onClick), {
                filter: function () {
                    return !options.unit.isLockedByTutorial();
                }
            });
        }
    },

    runAnimation: function () {
        const styles = cleverapps.styles.PrizeView;

        this.stopAllActions();
        this.runAction(new cc.RepeatForever(
            new cc.Sequence(
                new cc.MoveBy(styles.duration, 0, styles.delta).easing(cc.easeInOut(1.7)),
                new cc.MoveBy(styles.duration, 0, -styles.delta).easing(cc.easeInOut(1.7))
            )
        ));
    }
});

cleverapps.styles.PrizeView = {
    width: 90,
    height: 90,

    padding: {
        x: 12,
        y: 10
    },

    duration: 1,
    delta: 10,
    iconDy: 0,

    pointer: {
        dy: 4
    },

    animation: {
        x: { align: "center" },
        y: { align: "center", dy: 3 },
        scale: 0.8
    }
};
